<crm-document-form
  *ngIf="(loading$ | async) === false"
  [isModal]="true"
  [index]="index"
  [canDelete]="(form$ | async)?.isEdit"
  [canWrite]="(form$ | async)?.canWrite"
  [document]="document"
  [directions]="directions"
  [nds]="nds"
  [bankDetails]="bankDetails"
  (bankDetailsSearch)="searchBankDetails($event)"
  (createBasedOnClick)="createBasedOn()"
  [canCreateBasedOn]="
    (form$ | async)?.isEdit &&
    document.documentType?.sync1c === false &&
    !document.basedOnDocument &&
    !document.spawnedDocument
  "
  [canCreateCopyOn]="(form$ | async)?.isEdit && document.documentType?.sync1c === false"
  [canRepeatOn]="
    (form$ | async)?.isEdit &&
    (!document.documentType?.sync1c || document.company?.allDocumentTypesAllowed)
  "
  [canCreateTemplate]="(form$ | async)?.isEdit && document.documentType?.sync1c === false"
  (save)="saveDocument($event)"
  (delete)="deleteDocument()"></crm-document-form>

<crm-spinner *ngIf="loading$ | async"></crm-spinner>
